import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Card from "shared/Card";
import TicketGroup from "Events/Components/TicketGroup";
import styles from "./TicketingForm.module.css";
import cardStyles from "../../V1Components/SharedCardStyles.module.css";

/**Area to fill out ticketing information  */
export function TicketingForm({ ticketGroups, setTicketGroups }) {
  //fill state and state functions on initial render
  useEffect(() => {
    let limit = [];
    let available = [];
    let ticketsPer = [];
    let tickets = [];
    ticketGroups.forEach((group, index) => {
      limit[index] = group.limit;
      available[index] = group.available;
      ticketsPer[index] = group.ticketsPer;
      tickets[index] = group.tickets;
    });
    setLimit(limit);
    setAvailable(available);
    setTicketsPer(ticketsPer);
    updateTickets(tickets);
  }, []);

  //Local states populated from the global ticketgroups state
  const [limit, setLimit] = useState([]);
  const handleLimit = (value, index) => {
    let _limit = [...limit];
    _limit[index] = value;
    setLimit(_limit);
  };

  const [available, setAvailable] = useState([]);
  const handleAvailable = (value, index) => {
    let _available = [...available];
    _available[index] = value;
    setAvailable(_available);
  };

  const [ticketsPer, setTicketsPer] = useState([]);
  const handleTicketsPer = (value, index) => {
    let _ticketsPer = [...ticketsPer];
    _ticketsPer[index] = value;
    setTicketsPer(_ticketsPer);
  };

  const [tickets, updateTickets] = useState([]);
  const handleTickets = (value, index) => {
    let _tickets = [...tickets];
    _tickets[index] = value;
    updateTickets(_tickets);
  };

  //useEffect blocks for updating the ticketgroups on local state change
  useEffect(() => {
    let _ticketGroups = [...ticketGroups];
    _ticketGroups.forEach((ticket, index) => {
      _ticketGroups[index].limit = limit[index];
    });
    setTicketGroups(_ticketGroups);
  }, [limit]);

  useEffect(() => {
    let _ticketGroups = [...ticketGroups];
    _ticketGroups.forEach((ticket, index) => {
      _ticketGroups[index].available = available[index];
    });
    setTicketGroups(_ticketGroups);
  }, [available]);

  useEffect(() => {
    let _ticketGroups = [...ticketGroups];
    _ticketGroups.forEach((ticket, index) => {
      _ticketGroups[index].tickets = tickets[index];
    });
    setTicketGroups(_ticketGroups);
  }, [tickets]);

  useEffect(() => {
    let _ticketGroups = [...ticketGroups];
    _ticketGroups.forEach((ticket, index) => {
      _ticketGroups[index].available = available[index];
    });
    setTicketGroups(_ticketGroups);
  }, [available]);

  return (
    <Card
      children={
        <section>
          <div className={styles.bold}>TICKETING</div>
          <hr className={styles.hr} />
          <div className={styles.ticketGroup}>
            {available.length > 0 &&
              limit.length > 0 &&
              ticketGroups.length > 0 &&
              tickets.length > 0 &&
              ticketGroups.map((group, index) => (
                <TicketGroup
                  name={group.name}
                  available={available[index]}
                  setAvailable={(e) => handleAvailable(e, index)}
                  limit={limit[index]}
                  setLimit={(value) => handleLimit(value, index)}
                  ticketsPer={ticketsPer[index]}
                  setTicketsPer={(value) => handleTicketsPer(value, index)}
                  tickets={tickets[index]}
                  updateTickets={(value) => handleTickets(value, index)}
                  eventStartDate={group.eventStartDate}
                  key={index}
                />
              ))}
          </div>
        </section>
      }
    />
  );
}

TicketingForm.propTypes = {
  /**Array of ticket group objects (name-String, available-Number, limit-String, ticketsPer-string, tickets-Array)  */
  ticketGroups: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      available: PropTypes.number,
      setAvailable: PropTypes.func,
      limit: PropTypes.string,
      setLimit: PropTypes.shape({}),
      ticketsPer: PropTypes.string,
      setTicketsPer: PropTypes.shape({}),
      tickets: PropTypes.array,
      updateTickets: PropTypes.shape({}),
      eventStartDate: PropTypes.string,
    })
  ),
  /**Function that changes the ticket groups */
  setTicketGroups: PropTypes.func,
};
